import { render, staticRenderFns } from "./vsListItem.vue?vue&type=template&id=efd2b20e&lang=html"
import script from "./vsListItem.vue?vue&type=script&lang=js"
export * from "./vsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports